const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-t-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center text-white text-sm font-bold">
          Loading
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;